import { createSlice } from "@reduxjs/toolkit";

const drmExpireTableDataSlice = createSlice({
  name: "expireDrmtTableData",
  initialState: {
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setExpireDrmTableData: (state) => {
      state.isLoading = true;
    },
    setExpireDrmTableDataSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setExpireDrmTableDataFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    setResetExpireDrmTableDataState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setExpireDrmTableData,
  setExpireDrmTableDataSuccess,
  setExpireDrmTableDataFailure,
  setResetExpireDrmTableDataState,
} = drmExpireTableDataSlice.actions;

export default drmExpireTableDataSlice.reducer;
